module.exports = __webpack_public_path__ + "static/media/3DMapping.e9361063.svg";